import React from 'react';
import { createIconSetFromFontello } from 'react-native-vector-icons';
import { useThemeContext } from '../../hooks';
import fontelloConfig from '../../assets/icon-config.json';
// eslint-disable-next-line @typescript-eslint/no-unsafe-call
const Fontello = createIconSetFromFontello(fontelloConfig, 'GoPeerIcons', 'GopeerIcons.ttf');
export function Icon({ name, filled, size, color }) {
    const { color: themeColor } = useThemeContext();
    const rawName = `${name}-${filled ? 'filled' : 'regular'}`;
    const finalColor = color
        ? typeof color === 'function'
            ? color(themeColor)
            : color
        : themeColor.invert2.p100;
    return (React.createElement(Fontello, { name: rawName, size: size !== null && size !== void 0 ? size : 24, color: finalColor }));
}
//# sourceMappingURL=index.js.map